module.exports = __webpack_public_path__ + "img/1532722104.15b89fcb.jpg";